import { render } from "./TimelineYearProjectList.vue?vue&type=template&id=15844bbd"
import script from "./TimelineYearProjectList.vue?vue&type=script&lang=js"
export * from "./TimelineYearProjectList.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\rossc\\Desktop\\Mike\\Alldream Studios\\Presence\\Website\\Portfolio\\v10\\PortfolioSocialImpact\\portfolio\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__